import { joinConference } from '../../prejoin/actions.web';
import { SET_CONFIG_GUEST_JOIN } from '../config/actionTypes';
import { gumPending } from '../media/actions';
import { MEDIA_TYPE } from '../media/constants';
import { IGUMPendingState } from '../media/types';
import { createAndAddInitialAVTracks } from '../tracks/actions.web';
import { CLEAR_ERROR_CONFERENCE, SET_MANUAL_HANDLE_ERROR, SET_ROOM_ROLE_PARTICIPANT, SET_ROOMINFO } from './actionTypes';
export * from './actions.any';
/**
 * Starts audio and/or video for the visitor.
 *
 * @param {Array<MediaType>} media - The media types that need to be started.
 * @returns {Function}
 */
export function setupVisitorStartupMedia(media) {
    return (dispatch) => {
        // Clear the gum pending state in case we have set it to pending since we are starting the
        // conference without tracks.
        dispatch(gumPending([MEDIA_TYPE.AUDIO, MEDIA_TYPE.VIDEO], IGUMPendingState.NONE));
        if (media && Array.isArray(media) && media.length > 0) {
            dispatch(createAndAddInitialAVTracks(media));
        }
    };
}
export function clearErrorConference() {
    return {
        type: CLEAR_ERROR_CONFERENCE
    };
}
export function setRoomInfo(roomInfo) {
    return {
        type: SET_ROOMINFO,
        roomInfo
    };
}
export function setManualHandleError(isManual) {
    return {
        type: SET_MANUAL_HANDLE_ERROR,
        isManual
    };
}
export function setRoomRoleParticipant(roomRole) {
    return {
        type: SET_ROOM_ROLE_PARTICIPANT,
        roomRole
    };
}
/**
 * Will try to join the conference again in case it failed earlier with
 * {@link JitsiConferenceErrors.AUTHENTICATION_REQUIRED}. It means that Jicofo
 * did not allow to create new room from anonymous domain, but it can be tried
 * again later in case authenticated user created it in the meantime.
 *
 * @returns {Function}
 */
export function checkIfCanJoin() {
    return (dispatch, getState) => {
        const { authRequired, password } = getState()['features/base/conference'];
        /**
         * TODO:
         * Nếu là cuộc họp lên lịch
         * gọi api để lấy thông tin status cuộc họp
         */
        // const replaceParticipant = getReplaceParticipant(getState());
        // authRequired && dispatch(_conferenceWillJoin(authRequired));
        // authRequired?.join(password, replaceParticipant);
        dispatch(joinConference());
    };
}
export function setConfigGuestJoin(guestJoin) {
    return {
        type: SET_CONFIG_GUEST_JOIN,
        guestJoin
    };
}
